import { Reveal } from "./Reveal";
import { Check } from "lucide-react";

const included = [
  "Prima visita e TAC / panoramica",
  "Estrazioni dentarie necessarie",
  "4 impianti in titanio certificato",
  "Protesi provvisoria fissa in giornata",
  "Protesi definitiva dopo la guarigione: compresa nel prezzo in composito medicale (il più usato al mondo) con garanzia economica 10 anni, oppure puoi richiedere di effettuarla in ceramica nano ibrida (con un piccolo sovrapprezzo di 1.400 €)",
  "Garanzia economica 10 anni su tutto il lavoro compresi gli impianti (per 10 anni non spenderai più nulla)",
  "Controlli post-operatori inclusi",
  "Finanziamento con Compass o Cofidis (salvo approvazione della finanziaria)",
];

export const Pricing = () => (
  <section id="prezzo" className="py-24 md:py-32 px-6 md:px-12 bg-[#385244]" data-testid="pricing-section">
    <div className="max-w-7xl mx-auto">
      <Reveal>
        <p className="text-sm uppercase tracking-[0.2em] font-bold text-[#C98E6E] mb-4">Trasparenza prezzi</p>
        <h2 className="font-serif-display font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight text-white max-w-3xl">
          Quanto costano gli impianti dentali? Un prezzo chiaro. <em className="italic text-[#C98E6E]">Nessuna sorpresa.</em>
        </h2>
      </Reveal>
      <Reveal delay={0.15}>
        <div className="mt-16 grid lg:grid-cols-2 border border-white/20 rounded-[32px] overflow-hidden">
          <div className="p-10 md:p-14 flex flex-col justify-center border-b lg:border-b-0 lg:border-r border-white/20">
            <p className="text-white/70 text-lg">Arcata completa, tutto incluso</p>
            <p className="font-serif-display font-light text-7xl md:text-8xl lg:text-9xl text-white mt-4 tracking-tighter" data-testid="pricing-amount">
              €4.900
            </p>
            <p className="mt-6 text-white/60 text-sm leading-relaxed max-w-md">
              Prezzo indicativo per arcata, confermato con preventivo scritto dopo la valutazione clinica.
              Ogni piano di cura è definito dal direttore sanitario dello studio.
            </p>
            <a
              href="#contatti"
              className="mt-8 inline-flex w-fit items-center rounded-full bg-[#C98E6E] hover:bg-[#B37A5B] text-white font-bold px-8 py-4 transition-colors duration-300 active:scale-95"
              data-testid="pricing-cta-btn"
            >
              Chiedi informazioni
            </a>
          </div>
          <ul className="p-10 md:p-14 grid sm:grid-cols-1 gap-5 content-center" data-testid="pricing-inclusions">
            {included.map((item) => (
              <li key={item} className="flex items-start gap-4 text-white/90 text-base md:text-lg">
                <span className="mt-1 flex-shrink-0 w-6 h-6 rounded-full bg-[#C98E6E]/20 flex items-center justify-center">
                  <Check size={14} className="text-[#C98E6E]" />
                </span>
                {item}
              </li>
            ))}
          </ul>
        </div>
      </Reveal>
      <div className="mt-8 grid md:grid-cols-2 gap-6">
        <Reveal delay={0.1}>
          <div className="h-full border border-white/20 rounded-[28px] p-8 md:p-10 flex flex-col justify-between" data-testid="pricing-single-implant">
            <div>
              <p className="text-sm uppercase tracking-[0.15em] font-bold text-white/50">Impianto singolo</p>
              <p className="font-serif-display font-light text-5xl md:text-6xl text-white mt-3 tracking-tighter">€980</p>
              <p className="mt-4 text-white/60 text-sm leading-relaxed">
                Compreso dente in ceramica zirconio. La soluzione per sostituire un singolo dente mancante.
              </p>
            </div>
            <a href="#contatti" className="mt-6 inline-flex w-fit items-center text-[#C98E6E] hover:text-white font-bold text-sm transition-colors duration-300" data-testid="pricing-single-cta">
              Chiedi informazioni →
            </a>
          </div>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="h-full border border-white/20 rounded-[28px] p-8 md:p-10 flex flex-col justify-between" data-testid="pricing-zygomatic">
            <div>
              <p className="text-sm uppercase tracking-[0.15em] font-bold text-white/50">Implantologia zigomatica</p>
              <p className="font-serif-display font-light text-5xl md:text-6xl text-white mt-3 tracking-tighter">€9.900</p>
              <p className="mt-4 text-white/60 text-sm leading-relaxed">
                Hai poco osso o ti hanno detto che non puoi mettere impianti? Con gli impianti zigomatici
                puoi tornare a sorridere e masticare come un tempo.
              </p>
            </div>
            <a href="#contatti" className="mt-6 inline-flex w-fit items-center text-[#C98E6E] hover:text-white font-bold text-sm transition-colors duration-300" data-testid="pricing-zygomatic-cta">
              Chiedi informazioni →
            </a>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
